export default __webpack_public_path__ + "static/iphone-60c4a42532c79a9e57279419cb537033.png";